import { SharingMode } from '@zapier/design-system-zap-sharing/src/types';

export const hasDisabledSharing = (mode?: SharingMode) =>
  mode ? mode === 'disabled' : true;
